'use client';

import { useEffect, useState } from 'react';
import { legalApi } from '@/lib/api';
import type { LegalLinkItem } from '@/lib/legal-server';

const FALLBACK_LINKS: LegalLinkItem[] = [
  { slug: 'terms-and-conditions', title: 'Terms & Conditions', label: 'Terms', href: '/legal/terms-and-conditions', category: 'Agreements' },
  { slug: 'privacy-policy', title: 'Privacy Policy', label: 'Privacy', href: '/legal/privacy-policy', category: 'Policies' },
];

let cachedLinks: LegalLinkItem[] | null = null;

export function useLegalLinkRegistry() {
  const [links, setLinks] = useState<LegalLinkItem[]>(cachedLinks ?? FALLBACK_LINKS);

  useEffect(() => {
    if (cachedLinks) {
      setLinks(cachedLinks);
      return;
    }
    legalApi
      .linkRegistry()
      .then((res) => {
        const data = res.data?.data;
        if (Array.isArray(data) && data.length > 0) {
          cachedLinks = data;
          setLinks(data);
        }
      })
      .catch(() => {});
  }, []);

  return links;
}

export function resolveLegalHref(links: LegalLinkItem[], slug: string, fallback?: string): string {
  return links.find((l) => l.slug === slug)?.href ?? fallback ?? `/legal/${slug}`;
}
